export const arrayIncludesCount = (array, includesArray) => {
    let includesCount = 0;
    includesArray.forEach(item => {
        if (array.includes(item))
            includesCount++;
    });
    return includesCount;
};
